import React, { useState } from 'react';
import EditorSettings from '@wix/da-ds/pkg/Icons/24x24/EditorSettings';
import DaVideoPopup from '../DaVideoPopup';
import { ButtonProps } from '../../../../components/menus/buttons/types';
import { useTranslation } from 'react-i18next';
import EditorIconButton from '../../../../components/menus/_partials/EditorIconButton';

const Edit: React.FC<ButtonProps> = ({ editor }) => {
  const { t } = useTranslation('editor');
  const [showPopup, setShowPopup] = useState<boolean>(false);

  const onSelect = (src: string) => {
    editor
      .chain()
      .focus()
      .daVideoReplace({
        src,
      })
      .run();
    setShowPopup(false);
  };

  return (
    <>
      {showPopup && (
        <DaVideoPopup
          onCancel={() => setShowPopup(false)}
          onSubmit={onSelect}
        />
      )}
      <EditorIconButton
        featureId="node:video:edit"
        icon={EditorSettings}
        onClick={() => setShowPopup(true)}
        tooltipText={t('ext.video.button.edit')}
        aria-label={t('ext.video.button.edit')}
      />
    </>
  );
};
Edit.displayName = 'Edit';

export default Edit;
